import { render, staticRenderFns } from "./PostRelated.vue?vue&type=template&id=698e3229"
import script from "./PostRelated.vue?vue&type=script&lang=js"
export * from "./PostRelated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports